import styled from 'styled-components';

export const InitialisingLogContainer = styled.div`
  margin: 16px 0 0 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 12px;
`;
